import PropTypes from 'prop-types'
import React, {useCallback, useEffect, useState} from "react";
import {Button, TextField} from "@mui/material";
import debounce from 'lodash.debounce';
import FunctionsData from "../Functions/FunctionsData";

function parsePC(postCode,setPCError) {
    let x = false;
    x = ((postCode.length < 3 || postCode.length > 4) === true || postCode.match(/^[0-9]+$/) === null);
    setPCError(x);
}

/*
    This component is used to display the manual form
    @param selectPlace: function to select a place
    @param showManualForm: boolean to show the manual form
    @param setShowManualForm: function to set the showManualForm
 */
const DisplayManualForm = ({selectPlace,showManualForm,setShowManualForm}) => {

    const [city,setCity] = useState('');
    const [street,setStreet] = useState('');
    const [nr,setNr] = useState('');
    const [suburb,setSuburb] = useState('');
    const [postCode,setPostCode] = useState('');
    const [pcError,setPCError] = useState(false);
    const [valid,setValid] = useState(false);

    useEffect(() => {
        parsePC(postCode,setPCError);
        setValid (
            !((postCode.length < 3 || postCode.length > 4) === true || postCode.match(/^[0-9]+$/) === null) &&
            nr.length > 0 &&
            street.length > 0 &&
            city.length > 0 &&
            suburb.length > 0
        )
    },[nr,street,suburb,city,postCode])

    /*
        This function is called when the user clicks on the submit button
     */
    function submitAddress(e) {
        let res = ({
            "address": nr.toUpperCase() + " " + street.toUpperCase() + ", " + suburb.toUpperCase() + "," + city.toUpperCase() + "," + postCode,
            "SUBURB_NAME": suburb.toUpperCase(),
            "TOWN_CITY_MAILTOWN": city.toUpperCase(),
            "POSTCODE":postCode,
            "STREET_NAME": street.toUpperCase(),
            "STREET_NUMBER": nr.toUpperCase(),
            "cast(a.X_COORDINATE as float)": null,
            "Y_COORDINATE": null,
            "DPID": null,
            "address_optimised": ""
        });

        selectPlace(e,res)

    }

    if(showManualForm === false) return null;
    return (
        <div>
            <TextField error={(nr.length === 0)}
                       value={nr} id="outlined-basic" label={"Street number"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setNr(e.target.value)
                       }}
            />
            <TextField error={(street.length === 0)}
                       value={street} id="outlined-basic" label={" Street"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setStreet(e.target.value)
                       }}
            />

            <TextField error={(city.length === 0)}
                       value={city} id="outlined-basic" label={"City"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setCity(e.target.value)
                       }}
            />

            <TextField error={(suburb.length === 0)}
                       value={suburb} id="outlined-basic" label={"Suburb"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                            setSuburb(e.target.value)
                       }}
            />

            <TextField error={pcError}
                       value={postCode} id="outlined-basic" label={"Postcode"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setPostCode(e.target.value)
                       }}
            />

            <Button disabled={!valid}
                    sx={{width:'auto'}}
                    variant={"contained"}
                    onClick={submitAddress}>Use address</Button>
            <Button sx={{width:'auto'}} onClick={() => setShowManualForm(false)}>Cancel</Button>

        </div>
    )

}

/*
    This component is used to display the autocomplete
    @param close: boolean to close the autocomplete
    @param text: text to display in the input
    @param {object} row: row to display in the input
    @param {function} setGooglePlace: function to set the google place
 */
export default function LandingAutoComplete({close,text,row,setGooglePlace}) {

    const ph = (text || "Type your address");
    const [options,setOptions] = useState([]);
    const [value, setValue] = useState(row.formatted_address ?? '');
    const [valueP, setValueP] = useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [isSelected, setIsSelected] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(false);

    const [showManualForm, setShowManualForm] = React.useState(false);

    useEffect(() => {
        // console.log('value',value);
        if(row.formatted_address !== '') {
            setValue(row.formatted_address);
            setIsSelected(true);
            setSelectedRow({...row, address:row.formatted_address});
        }
    }, [row])

    const path = FunctionsData.getApiUrl('/api/search/location');

    /*
        This function is called when the user types in the input
        @param e: event
        @param value: value of the input
     */
    function selectPlace(e, row) {
        e.preventDefault();
        setIsSelected(true);
        // setValue(row.formatted_address);

        //console.log(row);
        if(close > 0) {
            setSelectedRow(row);
            setIsLoading(true);
            setGooglePlace(row);
        }else{
            setSelectedRow(row);
            setGooglePlace(row);
        }

        try {
            window.gtag('event', 'action', {
                category: 'User',
                action: 'Selected address from dropdown',
                postcode:row.POSTCODE,
                city:row.TOWN_CITY_MAILTOWN
            });
        }catch(e) {
            //
        }
    }

    /*
        This function is called when the user types in the input
        @param value: value
     */
    function getValueCLeanForSearch(value) {
        return value.replace(/ /g, '').toLowerCase() ;
    }

    /*
        Debounced function
        @param e: event
     */
    async function getList (e) {

        //console.log(e.target.value);
        setIsLoading(false);
        setValueP(e.target.value);

        if(e.target.value.length > 2) {
            const tkn = await FunctionsData.getCSRFToken();
            await fetch(path, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.vTkn,
                    'X-CSRF-Token':tkn.csrf // not used
                },
                body:JSON.stringify({'s':getValueCLeanForSearch(e.target.value)})
            })
                .then((res) => {
                    if (res.status === 401) {
                        localStorage.clear();
                        window.location.href = '/';
                    }
                    return res.json()
                })
                .then((d) => {
                    setIsLoading(false);
                    setOptions(d.data);
                });
        }

    }

    const debouncedChangeHandler = useCallback(
        debounce(getList, 300)
    , []);

    function loadManualForm(e) {
        e.preventDefault();
        setShowManualForm(true);

        try {
            window.gtag('event', 'action', {
                category: 'User',
                action: 'Clicked enter address manually'
            });
        }catch(e) {
            //
        }
    }

    const ShowList = () => {
        if(!options) return null;
        if(showManualForm === true) return <DisplayManualForm showManualForm={showManualForm}
                                                              setShowManualForm={setShowManualForm}
                                                              selectPlace={selectPlace}
        />
        if(isLoading === true) return (<div>Loading ...</div>);
        if (value.length ===0 && options.length === 0 && isLoading === true) return (<div>Loading ...</div>);
        if (value.length > 0 && options.length === 0 && isLoading === true) return (<div>Loading ...</div>);

        if (value.length > 0 && value.length < 4 && options.length === 0 && isLoading === false) return (
            <div>
                Please enter at least 3 characters ...
            </div>
            )
        if (value.length > 0 && options.length === 0 && isLoading === false) return (
            <div>
                No results found. Please try again or add your address <a href={"#"} onClick={loadManualForm}>manually</a>.
            </div>
        );

        return (
            <div>
                {options.map((d) => {
                   return (
                       <div key={(Date.now().toFixed(5)) + Math.random()} style={{width:'calc(100% - 20px)',textAlign:'left', border:'1px solid rgba(0,0,0,0.1', marginTop:10, padding:10}}>
                           <button onClick={(e) => selectPlace(e,d)} style={{padding:5, marginRight:10}}>Select</button>{d.address}
                       </div>
                   )
                })}
            </div>
        )
    }

    const ShowSelectedRow = () => {
        if(value === '') return null;
        return (
            <span></span>
        )
    }

    if(isSelected === true) return (
        <div className={"address-confirmed"}>
            <h3>Your address:</h3>
            {selectedRow.address} <a href="" onClick={(e) =>{
                e.preventDefault();
                setOptions([]);
                setIsSelected(false);
                }}>Change</a>
        </div>

    )

    if(showManualForm === true) return (
        <ShowList />
    );
    return (
        <div>
            <TextField id="outlined-basic"
                       label={ph}
                       placeholder={"# street, town, postcode"}
                       variant="outlined" sx={{width:'100%'}}
                       onChange={(e) => {
                           setValue(e.target.value);
                           debouncedChangeHandler(e)
                       }}
                       value={value}
            />
            <ShowSelectedRow />
            <ShowList />
        </div>
    )

}
